import { Box, Typography } from '@mui/material';

const AdminUsers = () => {
 return (
  <Box className="p-4">
   <Typography variant="h5">Admin Users</Typography>
  </Box>
 );
};

export default AdminUsers;


